import { mapState } from 'vuex';
import { LabelFilterWrapper } from './styles';
import { FILTER_KEYS, FILTER_ITEM_CLASS } from '@consts';

import FilterMixin from '../mixin';

const { LABEL } = FILTER_KEYS;

export default {
    name: 'LabelFilter',
    mixins: [FilterMixin],
    props: {
        handleSubmit: {
            type: Function,
        },
        filterVisible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            values: {
                type: LABEL,
                dimensionId: '',
                dimensionName: '',
                labelId: '',
                labelName: '',
            },
        };
    },
    computed: {
        ...mapState('newDashboard', ['dimensions']),
        labels() {
            const customBreakdownList = (this.dimensions || []).map(
                ({ id: dimensionId, name: dimensionName, labels }) =>
                    labels
                        ? labels.map(({ id: labelId, name: labelName }) => ({
                              labelId,
                              labelName,
                              dimensionId,
                              dimensionName,
                          }))
                        : []
            );

            return R.flatten(customBreakdownList);
        },
    },
    methods: {
        emitFilter() {
            const { values, currentState: state } = this;
            const { type, dimensionId, dimensionName, labelId, labelName } =
                values;

            const updatedValue = {
                type,
                filterBy: { dimensionId, dimensionName, labelId, labelName },
            };

            this.$emit('update', { value: updatedValue, state });
        },
        renderLabelOptions() {
            const {
                values,
                labels,
                keywords,
                normalizeText,
                highlightMatchingText,
                prefix,
                renderNoOptionFound,
                handleSubmit,
            } = this;
            const { type } = values;

            const filterText = normalizeText(keywords);
            const noOption = renderNoOptionFound();

            const renderer = (label) => {
                const { labelName = '', dimensionName = '' } = label;

                return (
                    <li
                        class={FILTER_ITEM_CLASS}
                        onClick={() => {
                            this.values = { ...values, ...label };
                            handleSubmit && handleSubmit({ value: label });
                        }}
                    >
                        <p
                            id="name"
                            domProps={{
                                innerHTML: highlightMatchingText(
                                    `${prefix}${labelName}`
                                ),
                            }}
                        />
                        <p id="dimensionGroup">{dimensionName}</p>
                    </li>
                );
            };

            if (labels.length) {
                const filterByKeyword = labels.filter(
                    ({ labelName }) =>
                        normalizeText(labelName).indexOf(filterText) > -1 ||
                        normalizeText(this.$t(`FILTERS.${type}`)).indexOf(
                            filterText
                        ) > -1
                );

                return filterByKeyword.length
                    ? filterByKeyword.map(renderer)
                    : noOption;
            } else {
                return noOption;
            }
        },
    },
    render() {
        const {
            shouldHideFilter,
            filterVisible,
            getCommonHeader,
            renderLabelOptions,
        } = this;

        if (shouldHideFilter && !filterVisible) return null;

        return (
            <LabelFilterWrapper>
                {getCommonHeader()}
                {renderLabelOptions()}
            </LabelFilterWrapper>
        );
    },
};
